export enum SmartContractType {
  ERC721_LIMITED_TRADEABLE = 'ERC721_LIMITED_TRADEABLE',
  ERC721_LIMITED = 'ERC721_LIMITED',
  CUSTOM = 'CUSTOM',
  ERC721_BASIC = 'ERC721_BASIC',
  ERC721_BASIC_ENUMERABLE = 'ERC721_BASIC_ENUMERABLE',
  ERC721_PAYMENT_SHARES = 'ERC721_PAYMENT_SHARES',
  ERC721_PAYMENT_NO_SHARES = 'ERC721_PAYMENT_NO_SHARES',
  ERC721_LIMITED_TRADEABLE_ROYALTIES = 'ERC721_LIMITED_TRADEABLE_ROYALTIES',
  ERC721_BASIC_BURNABLE = 'ERC721_BASIC_BURNABLE',
}
export const DEFAULT_CONTRACT = SmartContractType.ERC721_LIMITED_TRADEABLE;

export interface IContractFeatureUiOption {
  icon: string;
  nameKey: string;
  value: SmartContractFeature;
  descriptionKey: string;
}

export type SmartContractFeature =
  | 'ownable'
  | 'erc721'
  | 'shares'
  | 'lazyMint'
  | 'payments'
  | 'ownerMint'
  | 'airdrop'
  | 'enumerable'
  | 'burn'
  | 'limited'
  | 'royalties'
  | 'multichain';
